/** Compute month form on the balance snapshot runs page. */
export interface BalanceSnapshotComputeFormModel {
  /** Any day of the month to compute; null until the user picks one. */
  month: Date | null;
}

export const balanceSnapshotComputeFieldLabels: Record<keyof BalanceSnapshotComputeFormModel, string> = {
  month: 'BalanceSnapshotRun_Details_Form_Field_Month',
};
